import { Component, Input, OnDestroy } from '@angular/core';
import {
  ControlValueAccessor,
  UntypedFormControl,
  UntypedFormGroup,
  NgControl,
} from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'mojo-numeric-input',
  templateUrl: './mojo-numeric-input.component.html',
  styleUrls: ['./mojo-numeric-input.component.scss'],
})
export class MojoNumericInputComponent implements ControlValueAccessor, OnDestroy {
  @Input() color: ThemePalette = 'accent';
  @Input() label: string;
  @Input() min = 0;
  private subscription = new Subscription();
  control = new UntypedFormControl();
  form = new UntypedFormGroup({
    input: this.control,
  });

  constructor(private ngControl: NgControl) {
    ngControl.valueAccessor = this;
    this.subscription.add(
      this.control.valueChanges.subscribe((value) => {
        this.onChange(value);
      }),
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  writeValue(value) {
    this.control.setValue(value, { emitEvent: false });
  }

  registerOnTouched(onTouch: (value: any) => void) {
    this.onTouched = onTouch;
  }

  registerOnChange(onChange: (value: any) => void) {
    this.onChange = onChange;
  }

  onTouched($event) {}

  onChange($event) {}

  upClicked() {
    const newValue = this.control.value + 1;
    this.writeValue(newValue);
    this.onChange(newValue);
  }

  downClicked() {
    const newValue = this.control.value - 1;
    this.writeValue(newValue);
    this.onChange(newValue);
  }
}
